<div class="form-wrapper step6" [formGroup]="emailNotificationForm">
  <p>Please enter recipient information for scan results notifications.</p>
  <p><strong>Note:</strong> Only Roche and Genentech email addresses can be used.</p>

  <div class="form-group">
    <h4 class="section-title">Contact Information</h4>
    <label class="field-label">Email addresses</label>
    <table class="table email-table">
      <thead>
      <tr>
        <th>Email</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of emails; let i = index">
        <td>
          <div class="email-row">
            <span class="email-label">Email address {{ i + 1 }}</span>
            <div *ngIf="item.isEditing; else readOnlyEmail" class="email-edit-cell">
              <mat-form-field class="compact-field" [class.has-error]="!!item.error">
                <input matInput [(ngModel)]="emails[i].value" [ngModelOptions]="{standalone: true}" placeholder="e.g. mail@roche.com" (blur)="validateEmailValue(i)">
              </mat-form-field>
              <div class="email-validation-message" [class.is-visible]="item.error">{{ item.error }}</div>
            </div>
            <ng-template #readOnlyEmail>
              <div class="email-display-cell">
                <span>{{ item.value }}</span>
              </div>
            </ng-template>
          </div>
        </td>
        <td>
          <div class="email-action-group" *ngIf="!item.isEditing; else editingActions">
            <button type="button" class="btn btn-raised btn-default email-action-btn" (click)="editEmail(i)">Edit</button>
            <button type="button" class="btn btn-raised btn-danger email-action-btn" (click)="deleteEmail(i)">Delete</button>
          </div>
          <ng-template #editingActions>
            <div class="email-action-group">
              <button type="button" class="btn btn-raised btn-success email-action-btn" (click)="saveEmailEdit(i)">Save</button>
              <button type="button" class="btn btn-raised btn-default email-action-btn" (click)="cancelEmailEdit(i)">Cancel</button>
            </div>
          </ng-template>
        </td>
      </tr>
      </tbody>
    </table>

    <ng-container *ngIf="emails.length < 3">
      <mat-form-field class="w-100">
        <input matInput [(ngModel)]="emailInput" [ngModelOptions]="{standalone: true}" placeholder="e.g. mail@roche.com">
        <mat-hint *ngIf="getAddEmailHintMessage()">{{ getAddEmailHintMessage() }}</mat-hint>
      </mat-form-field>
      <button type="button" class="btn btn-raised btn-success btn-new" [disabled]="!canAddEmail()" (click)="addEmail()">Add new</button>
    </ng-container>
  </div>

  <div class="notification-group">
    <label class="field-label">Notification to be monitored</label>
    <div class="notification-checkbox-group">
      <div class="notification-checkbox">
        <mat-checkbox formControlName="positiveVerification" (change)="toggleVerificationFlags()">Positive Verifications</mat-checkbox>
      </div>
      <div class="notification-checkbox">
        <mat-checkbox formControlName="negativeVerification" (change)="toggleVerificationFlags()">Negative Verifications</mat-checkbox>
      </div>
    </div>

    <label class="field-label">Notification settings</label>
    <div class="notification-options">
      <div class="notification-choice">
        <mat-radio-button [checked]="isNotificationTypeSelected('immediately')"
                          [disabled]="!anyVerificationSelected()"
                          (change)="selectNotificationType('immediately')">Immediately</mat-radio-button>
      </div>
      <div class="notification-choice">
        <mat-radio-button [checked]="isNotificationTypeSelected('daily')"
                          [disabled]="!anyVerificationSelected()"
                          (change)="selectNotificationType('daily')">Daily</mat-radio-button>
      </div>
      <div class="notification-choice">
        <mat-radio-button [checked]="isNotificationTypeSelected('weekly')"
                          [disabled]="!anyVerificationSelected()"
                          (change)="selectNotificationType('weekly')">Weekly (on Fridays)</mat-radio-button>
      </div>
      <div class="notification-choice">
        <mat-radio-button [checked]="isNotificationTypeSelected('off')"
                          [disabled]="!anyVerificationSelected()"
                          (change)="selectNotificationType('off')">Off</mat-radio-button>
      </div>
    </div>
  </div>

  <div class="text-danger validation-summary" [class.is-visible]="validationMessage">{{ validationMessage }}</div>
  <button class="btn btn-raised btn-default btn-back" (click)="back()">Back</button>
  <button class="btn btn-raised btn-default btn-next" (click)="save()">Save</button>
</div>
